import { Flex } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';
import { useModal } from 'Store/modal';
import { TextRegular } from 'UiKit/typography';

const useConfirmationModal = () => {
  const { t } = useTranslation('schedule-generate');
  const { onOpenModal, onResetModal } = useModal();

  const onOpenModalConfirmationSubmit = ({ onConfirm }) => {
    onOpenModal({
      width: '400px',
      isOpen: true,
      type: 'warning',
      title: t('saveScheduleSetTitle'),
      contentDescription: (
        <Flex flexDirection={'column'} gap={'16px'} width={'450px'}>
          <TextRegular>{t('saveScheduleSetDesc1')}</TextRegular>
          <TextRegular>{t('saveScheduleSetDesc2')}</TextRegular>
        </Flex>
      ),
      showPrimaryButton: true,
      showSecondaryButton: true,
      primaryButtonText: t('saveScheduleSetConfirmButton'),
      secondaryButtonText: t('saveScheduleSetCancelButton'),
      onClickPrimaryButton: () => {
        onConfirm();
        onResetModal();
      },
      onClickSecondaryButton: onResetModal,
    });
  };

  return { onOpenModalConfirmationSubmit };
};

export default useConfirmationModal;
